export default __webpack_public_path__ + "static/media/calendar.071359b7.svg";